import React from 'react';
import type { JobInfoRoleDetail } from '../../api/jobInfoApi';
import JobRoleDetailPanel from './JobRoleDetailPanel';
import '../../styles/interview-detail-modal.css';
import './JobRoleModalStack.css';

export const MAX_ROLE_MODAL_STACK = 5;
const PEEK_OFFSET_PX = 16;

export interface RoleModalEntry {
  id: string;
  roleId: string;
  role: JobInfoRoleDetail | null;
  isLoading: boolean;
  error: string | null;
}

const PEEK_ACCENTS = [
  { bg: '#1e3a5f', border: '#3b82f6' },
  { bg: '#14532d', border: '#22c55e' },
  { bg: '#450a0a', border: '#ef4444' },
  { bg: '#422006', border: '#eab308' },
  { bg: '#3b0764', border: '#a855f7' },
];

interface JobRoleModalStackProps {
  stack: RoleModalEntry[];
  isBuilding: boolean;
  onCloseTop: () => void;
  onBuildInterview: (selectedLevel?: number) => void;
  onRelatedRoleSelect: (roleId: string) => void;
}

const JobRoleModalStack: React.FC<JobRoleModalStackProps> = ({
  stack,
  isBuilding,
  onCloseTop,
  onBuildInterview,
  onRelatedRoleSelect,
}) => {
  if (stack.length === 0) return null;

  const topEntry = stack[stack.length - 1];
  const peekEntries = stack.slice(0, -1);
  const stackDepth = stack.length;

  return (
    <div className="job-role-modal-stack-overlay" onClick={onCloseTop}>
      <div
        className="job-role-modal-stack"
        style={{ paddingTop: peekEntries.length * PEEK_OFFSET_PX }}
        onClick={(e) => e.stopPropagation()}
      >
        {peekEntries.map((entry, index) => {
          const accent = PEEK_ACCENTS[index % PEEK_ACCENTS.length];
          const label = entry.role?.role_name || (entry.isLoading ? 'Loading...' : entry.roleId);

          return (
            <div
              key={entry.id}
              className="job-role-modal-peek"
              style={{
                top: index * PEEK_OFFSET_PX,
                zIndex: index + 1,
                backgroundColor: accent.bg,
                borderColor: accent.border,
              }}
              aria-hidden
            >
              <span className="job-role-modal-peek__name">{label}</span>
              {entry.role?.domain && (
                <span className="job-role-modal-peek__domain">{entry.role.domain}</span>
              )}
            </div>
          );
        })}

        <div className="job-role-modal-stack__front" style={{ zIndex: stackDepth }}>
          <JobRoleDetailPanel
            role={topEntry.role}
            isLoading={topEntry.isLoading}
            error={topEntry.error}
            isBuilding={isBuilding}
            onClose={onCloseTop}
            onBuildInterview={onBuildInterview}
            onRelatedRoleSelect={onRelatedRoleSelect}
          />
        </div>
      </div>
    </div>
  );
};

export default JobRoleModalStack;
